var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"progress-bar",staticClass:"progress-bar",style:(_vm.loadingBarWidth)})
}
var staticRenderFns = []

export { render, staticRenderFns }